/* istanbul ignore file */
import { defineMessages } from 'react-intl';

export const dialogHeaderMessages = defineMessages({
  back: {
    id: 'Dialog.Header.back',
    defaultMessage: 'Zurück',
  },
  close: {
    id: 'Dialog.Header.close',
    defaultMessage: 'Schließen',
  },
});
